<template>
  <div>
    <header>
      <Header msg="Header" />
      <SettingsHeader msg="SettingsHeader" />
    </header>
    <main>
      <div class="container">
        <div class="editor">
          <p>頁面版本：{{ version }}-{{ uiVersion }}</p>
          <p>系統版本：{{ beVersion }}</p>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
// Guide:
// import './'  // 同一層目錄開始找
// import '../' // 上一層目錄開始找
// import '@/'  // src目錄下開始找
// import ''    // 直接打名稱則是node_modules

// @ is an alias to /src
import Header from "@/components/Header.vue";
import SettingsHeader from "@/components/SettingsHeader.vue";
import apis from "@/services/apis";

export default {
  name: "home",
  data() {
    return {
      beVersion: "",
    };
  },
  components: {
    SettingsHeader,
    Header,
  },
  computed: {
    version() {
      return process.env.VUE_APP_VERSION;
      // return GLOBAL_ENV_VERSION;
    },
    uiVersion() {
      return process.env.VUE_APP_UIVERSION;
    }
  },
  methods: {
    getBackendVersion() {
      return apis.getBeSystemVersion().then((response) => {
        this.beVersion = response.version;
      });
    },
  },
  mounted() {
    console.log(JSON.stringify(process.env));
    this.getBackendVersion();
  },
};
</script>

<style scoped>
/* @import '../assets/css/theme_default.css'; */
</style>
